const localState = {
    schedule: {
        date_from: '',
        date_till: '',
        time_from: '',
        time_till: '',
        week_days: [1, 2, 3, 4, 5],
    },
}

const mutations = {
    clearSchedule: (state) => {
        state.schedule = {
            date_from: '',
            date_till: '',
            time_from: '',
            time_till: '',
            week_days: [1, 2, 3, 4, 5],
        }
    },
    setSchedule: (state, newSchedule) => {
        state.schedule = {
            ...newSchedule,
        }
    },
}

const actions = {
    async create(_, {
        id,
        type,
        schedule,
    }) {
        try {
            const response = await this.$api.specialists.createTimesheets({
                type,
                id,
            }, schedule)

            if (response.status === 204) {
                localStorage.setItem(`master_${id}_schedule`, JSON.stringify(schedule))

                this.commit('specialists/setState', {
                    type: 'created_id',
                    data: null,
                })
                return response
            }
        } catch (err) {
            console.log(err)

            return err.response
        }
    },

    async fetch(_, {
        type,
        day,
    }) {
        const query = `?date=${day}`

        const response = await this.$api.specialists.fetchTimesheets({
            type,
            query,
        })

        return response.data.data
    },
}

const getters = {
    scheduleGetters: (state) => state.schedule,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
